import { render, staticRenderFns } from "./PhotogrammetryHealingCaps.vue?vue&type=template&id=2b1a4897"
import script from "./PhotogrammetryHealingCaps.vue?vue&type=script&lang=js"
export * from "./PhotogrammetryHealingCaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports